import React from "react";

export function MaterialSymbolsMenu({ onClick }: { onClick: () => void }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            className="cursor-pointer"
            onClick={onClick}
        >
            <path fill="#fff" d="M3 18v-2h18v2zm0-5v-2h18v2zm0-5V6h18v2z"></path>
        </svg>
    );
}
